import { App, Directive } from "vue";
import auth from "./modules/auth";
import draggable from "./modules/draggable";
import debounce from "./modules/debounce";
import throttle from "./modules/throttle";
import focus from "./modules/focus";
import highlight from "@/views/directives/modules/hightLight";
import selectLoadMore from "@/views/directives/modules/selectLoadMore";

const directivesList: { [key: string]: Directive } = {
    auth,
    draggable,
    debounce,
    throttle,
    focus,
    highlight,
    selectLoadMore
};

const directives = {
    install: function (app: App<Element>) {
        Object.keys(directivesList).forEach(key => {
            app.directive(key, directivesList[key]);
        });
    }
};

export default directives;
